import {
    ConsolidationBasisOptionsResult,
    ConsolidationRelationshipResponse,
} from "@common/schemas/domains/accounting/consolidation.schema";
import { ConsolidationEntityRelationshipType } from "@common/types/domains/accounting/consolidation";
import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import {
    FULL_OWNERSHIP_PERCENTAGE,
    isActiveRelationship,
} from "../ownershipGraph.helpers";

export const CONSOLIDATION_BASIS_LABELS: Record<AccountingLedgerBasis, string> =
    {
        [AccountingLedgerBasis.cash]: "Cash ledger",
        [AccountingLedgerBasis.accruals]: "Accrual ledger",
    };

export function isLatestBasisOptionsRequest(
    requestId: number,
    latestRequestId: number,
): boolean {
    return requestId === latestRequestId;
}

export function getDefaultConsolidationLedgerSelections(
    ledgerOptionsByEntityUuid: ConsolidationBasisOptionsResult["ledgerOptionsByEntityUuid"],
): Record<string, string> {
    const ledgerIdsByEntityUuid: Record<string, string> = {};
    for (const [entityUuid, ledgerOptions] of Object.entries(
        ledgerOptionsByEntityUuid,
    )) {
        const defaultLedger =
            ledgerOptions.find(
                (ledger) => ledger.basis === AccountingLedgerBasis.cash,
            ) ?? ledgerOptions[0];
        if (defaultLedger) {
            ledgerIdsByEntityUuid[entityUuid] = defaultLedger.id;
        }
    }
    return ledgerIdsByEntityUuid;
}

interface ConsolidationCreationBasisEntityUuidsParams {
    parentEntityUuid: string;
    memberEntityUuids: string[];
    relationships: ConsolidationRelationshipResponse[];
}

export function getConsolidationCreationBasisEntityUuids({
    parentEntityUuid,
    memberEntityUuids,
    relationships,
}: ConsolidationCreationBasisEntityUuidsParams): string[] {
    const ownershipPercentagesByMemberUuid = new Map<string, number | null>();
    relationships.forEach((relationship) => {
        if (
            isActiveRelationship(relationship) &&
            relationship.type ===
                ConsolidationEntityRelationshipType.ownership &&
            relationship.sourceEntityUuid === parentEntityUuid
        ) {
            ownershipPercentagesByMemberUuid.set(
                relationship.targetEntityUuid,
                relationship.ownershipPercentage,
            );
        }
    });

    return [
        parentEntityUuid,
        ...memberEntityUuids.filter((entityUuid) => {
            const ownershipPercentage =
                ownershipPercentagesByMemberUuid.get(entityUuid);
            return (
                ownershipPercentage === undefined ||
                ownershipPercentage === FULL_OWNERSHIP_PERCENTAGE
            );
        }),
    ];
}
